import { axios } from '@getgreenline/homi-shared'

export interface IOrgUserMigrationCompany {
  id: number
  name: string
}

export interface IOrgUserMigrationUser {
  userId: string
  name: string
  email: string | null
  companies: IOrgUserMigrationCompany[]
}

export interface IOrgUserMigrationPreview {
  candidates: IOrgUserMigrationUser[]
  alreadyAssigned: IOrgUserMigrationUser[]
}

export interface IApplyOrgUserMigrationResult {
  migrated: number
  alreadyAssigned: number
}

/**
 * `admin` targets the admin dashboard route, reachable by super admins only.
 * `org` targets the organization route, reachable by users already assigned to the organization —
 * the users this migration creates.
 */
export type OrgUserMigrationScope = 'admin' | 'org'

export const orgUserMigrationPath = (
  organizationId: number,
  scope: OrgUserMigrationScope,
): string =>
  scope === 'admin'
    ? `/api/v1/admin/organizations/${organizationId}/user-migration`
    : `/api/v1/organizations/${organizationId}/user-migration`

export const getOrgUserMigrationPreview = (
  organizationId: number,
  scope: OrgUserMigrationScope,
): Promise<IOrgUserMigrationPreview> =>
  axios.get(orgUserMigrationPath(organizationId, scope)).then((r) => r.data)

export const applyOrgUserMigration = (
  organizationId: number,
  userIds: string[],
  scope: OrgUserMigrationScope,
): Promise<IApplyOrgUserMigrationResult> =>
  axios.post(orgUserMigrationPath(organizationId, scope), { userIds }).then((r) => r.data)
